import React from 'react';
import Chip from '@mui/material/Chip';

export type StatusTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

interface StatusChipProps {
  label: React.ReactNode;
  tone?: StatusTone;
  size?: 'small' | 'medium';
}

const TONE_COLOR: Record<StatusTone, 'default' | 'primary' | 'success' | 'warning' | 'error' | 'info'> = {
  neutral: 'default',
  accent: 'primary',
  success: 'success',
  warning: 'warning',
  danger: 'error',
  info: 'info',
};

/** Flat, square status badge built on MUI Chip with a fixed tone→color map. */
const StatusChip: React.FC<StatusChipProps> = ({ label, tone = 'neutral', size = 'small' }) => (
  <Chip
    label={label}
    size={size}
    color={TONE_COLOR[tone]}
    variant={tone === 'neutral' ? 'outlined' : 'filled'}
    sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em', fontSize: '0.7rem' }}
  />
);

export default StatusChip;
